// Maps a read task (TaskReadDto from the API) plus optional field overrides into the TaskUpdateDto
// the PUT endpoint expects. The frontend always holds the whole task, so every mutation (inline
// toggle or edit-modal save) sends the full state — no PATCH needed.
export function toUpdateDto(task, overrides = {}) {
  const t = { ...task, ...overrides };
  return {
    title: t.title,
    description: t.description ?? null,
    dueDate: t.dueDate ?? null,
    isImportant: !!t.isImportant,
    isCompleted: !!t.isCompleted,
    assigneeUserId: t.assigneeUserId ?? null,
    candidateId: t.candidateId ?? null,
    projectId: t.projectId ?? null,
    clientId: t.clientId ?? null,
  };
}
